import { IFRAME_CALLBACK_URL, QUICK_SEARCH_URL, SITEPLAN_PAGE_URL } from 'Routes/constants';
type RoutesConf = Record<string, RouteConf>;
export const routesConf: RoutesConf = {
  account: {
    baseUrl: '/account',
  },
  accountSearches: {
    baseUrl: '/account/searches',
  },
  activateAccount: {
    baseUrl: '/activateAccount',
  },
  booking: {
    baseUrl: '/booking',
    args: ['page'],
  },
  bookings: {
    baseUrl: '/account/bookings/:bookingId/stay/:stayId',
  },
  accountPrePayment: {
    baseUrl: '/account/bookings/:bookingId/stay/:stayId/pre-payment',
  },
  b2bBookingPrePayment: {
    baseUrl: '/account/proposal/:proposalId/pre-payment',
  },
  banking: {
    baseUrl: '/booking/banking',
  },
  summary: {
    baseUrl: '/booking/summary',
  },
  confirmation: {
    baseUrl: '/confirmation',
  },
  contactInfo: {
    baseUrl: '/bi',
    args: ['proposalId'],
  },
  dashboard: {
    baseUrl: '/account/dashboard',
  },
  editorialArticle: {
    baseUrl: '/articles/:slug',
  },
  editorialTheme: {
    baseUrl: '/themes/:slug',
  },
  error: {
    baseUrl: '/error',
  },
  fragments: {
    baseUrl: '/fragments/:fragment',
  },
  greatMembers: {
    baseUrl: '/great-members',
  },
  home: {
    baseUrl: '/',
  },
  iframeCallback: {
    baseUrl: IFRAME_CALLBACK_URL,
  },
  newsletterConfirmation: {
    baseUrl: '/newsletter/c',
    args: [
      {
        name: 'type',
        restrict: {
          subscription: 's',
          management: 'm',
        },
      },
    ],
  },
  newsletterSubscription: {
    baseUrl: '/newsletter/s',
  },
  newsletterUnsubscription: {
    baseUrl: '/newsletter/u',
    args: ['subscriptionId'],
  },
  offer: {
    baseUrl: '/o',
    args: ['offerName'],
  },
  pax: {
    baseUrl: '/pax',
  },
  paxConfirmation: {
    baseUrl: '/paxConfirmation',
  },
  payment: {
    baseUrl: '/pi',
    args: ['proposalId'],
  },
  paymentConfirmation: {
    baseUrl: '/account/bookings/:bookingId/payment-confirmation',
  },
  paymentNotification: {
    baseUrl: '/payment-notification',
    args: ['paymentId', 'locale'],
  },
  paymentRedirect: {
    baseUrl: '/payment-redirect',
  },
  claims: {
    baseUrl: '/account/claims',
  },
  claimsForm: {
    baseUrl: '/account/claims/form',
  },
  claimsConfirmation: {
    baseUrl: '/account/claims/confirmation',
  },
  stays: {
    baseUrl: '/account/stays',
  },
  prePayment: {
    baseUrl: '/pre-payment',
  },
  profile: {
    baseUrl: '/account/profile',
  },
  search: {
    baseUrl: '/s',
  },
  searches: {
    baseUrl: '/account/searches',
  },
  siteplan: {
    baseUrl: SITEPLAN_PAGE_URL,
  },
  signout: {
    baseUrl: '/signout',
  },
  stepup: {
    baseUrl: '/stepup',
  },
  sponsorship: {
    baseUrl: '/account/sponsorship',
  },
  cruises: {
    baseUrl: '/d/croisieres',
  },
  optionConfirmation: {
    baseUrl: '/option/c',
    args: ['status'],
  },
  optionConfirmationError: {
    baseUrl: '/option-error/c',
    args: ['status', 'error_code'],
  },
  quickSearch: {
    baseUrl: QUICK_SEARCH_URL,
  },
};
